import Navbar from "./navbarCategory"
import StyledFlickity from "./styledFlickity"
import React, { useState, useEffect } from 'react';
import api from './setAxios';
import config from '../config/staticData';

const Header = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const load = async () => {
            try {
                const result = await api.get("/blog/GetBlogsByRelationTypeAsync/mostVisited");
                setBlogs(result.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        load();
    }, []);

    // Flickity options for different instances
    const flickityAdvOptions = {
        initialIndex: 2,
        watchCSS: true
    };

    const flickityAdvContent = blogs.map((item, index) => {
        return (
            <img className={`item item${index}`} key={index} src={`${config.blogPath}${item.blogPic}`} alt={item.title} />
        );
    });

    return(
        <>
        <Navbar />

        <header className="header">
            <div className="banner">
                <h3>
                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ
                </h3>
            </div>
        </header>
        <div className="content-divider"></div>
        <section className="categoryAdv" >
          <StyledFlickity flickityOptions={flickityAdvOptions} flickityStyle={'carousel'} flickityContent={flickityAdvContent} />
        </section>
        </>
    )
}
export default Header;